// === Grid View Card Creation ===

import { escapeHtml } from '../utils/dom.js';
import { getHeroBackground } from '../utils/image.js';
import { isDone } from '../services/completion-service.js';

// Small inline icons for the quiet "Complete" toggle.
const CIRCLE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="9" stroke-width="2"/></svg>`;
const CHECK_ICON = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/></svg>`;

export function createCard(item, isUrgent) {
  const done = isDone(item.id);
  const bg = getHeroBackground(item);

  const container = document.createElement('div');
  container.className = `flip-container ${done ? 'done' : ''} ${isUrgent ? 'urgent-card' : ''}`;

  // The whole card is clickable → opens the detail modal. The Complete
  // button stops propagation so it doesn't also open the modal.
  container.innerHTML = `
    <div class="card-clickable" id="flip-${item.id}" role="button" tabindex="0"
         onclick="app.openCard('${item.id}')"
         onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();app.openCard('${item.id}')}">
      <div class="card-hero">
        <div class="card-hero-bg" style="background-image: ${bg}"></div>
        <span class="card-badge">${escapeHtml(item.meta.category)}</span>
      </div>
      <div class="card-body">
        <h3 class="card-title">${escapeHtml(item.content.title)}</h3>
        <p class="card-desc">${escapeHtml(item.content.summary)}</p>

        <div class="card-actions-area">
          <button class="btn btn-complete ${done ? 'is-done' : ''}" onclick="app.toggle('${item.id}', event)">
             ${done ? CHECK_ICON : CIRCLE_ICON}
             <span>${done ? 'Done' : 'Complete'}</span>
          </button>
        </div>
      </div>
    </div>
  `;
  return container;
}
